const INTERVAL_RATIO = 1 / 3;
const THROTTLE_MS = 500;

let lastKeepAlive = 0;
let intervalMs: number | null = null;
let checkFn: (() => void) | null = null;
let isThrottled = false;

const now = () => Date.now();

const onUserActivity = () => {
  // skip until timeout clears
  if (isThrottled) return;
  isThrottled = true;

  // throttle high-frequency events to max 1/2 sec
  setTimeout(() => {
    isThrottled = false;
    if (intervalMs && checkFn && now() - lastKeepAlive > intervalMs) {
      checkFn();
      lastKeepAlive = now();
    }
  }, THROTTLE_MS);
};

const addListeners = () => {
  document.addEventListener('click', onUserActivity);
  document.addEventListener('keydown', onUserActivity);
  document.addEventListener('mousemove', onUserActivity, { passive: true }); // don't block scroll
  document.addEventListener('scroll', onUserActivity, { passive: true });
};

const removeListeners = () => {
  document.removeEventListener('click', onUserActivity);
  document.removeEventListener('keydown', onUserActivity);
  document.removeEventListener('mousemove', onUserActivity);
  document.removeEventListener('scroll', onUserActivity);
};

export const activityTracker = {
  start(timeoutMinutes: number | null | undefined, callback: () => void) {
    this.stop();
    if (timeoutMinutes && timeoutMinutes > 0) {
      intervalMs = timeoutMinutes * 60 * 1000 * INTERVAL_RATIO;
      checkFn = callback;
      lastKeepAlive = now();
      addListeners();
    }
  },

  stop() {
    intervalMs = null;
    checkFn = null;
    removeListeners();
  },

  markApiCall() {
    lastKeepAlive = now();
  },
};
